import { render, staticRenderFns } from "./request-account.vue?vue&type=template&id=5343121a&"
import script from "./request-account.vue?vue&type=script&lang=js&"
export * from "./request-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports